import { render, staticRenderFns } from "./Spider.vue?vue&type=template&id=208d6a2e&"
import script from "./Spider.vue?vue&type=script&lang=ts&"
export * from "./Spider.vue?vue&type=script&lang=ts&"
import style0 from "./Spider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports